import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`
export const SummaryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.background};
  padding: 0 20px 20px 20px;
  border-radius: 16px;
`

export const FormWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  font-size: 14.5px;
  font-weight: 400;
  width: 100%;
`
// -------------

export const ColWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: 14.5px;
  font-weight: 400;
  width: 100%;
`
export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 5px;
  width: 100%;
`
export const Title = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  color: ${({ theme }) => theme.colors.primary};
  width: 100%;
  font-size: 20px;
`
export const Error = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  color: ${({ theme }) => theme.colors.red};
  width: 100%;
  font-size: 20px;
`
export const Text = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  color: ${({ theme }) => theme.colors.primary};
  width: 100%;
  font-size: 14px;
`
